"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpanSubForm = void 0;
const core_api_1 = require("@ikegps/core-api");
const __1 = require("..");
class SpanSubForm {
    constructor(spanField) {
        this.spanField = spanField;
        if (this.spanField.subFormType !== core_api_1.SubFormType.SPAN) {
            throw new Error("SubForm instance's schema must have type SPAN to be passed into SpanSubForm");
        }
        if (!this.spanField.subFormSpanTypeState) {
            throw new Error("SubForm instance's schema is type SPAN but is missing the SubFormSpanTypeState");
        }
        this.subFormSpanTypeState = this.spanField.subFormSpanTypeState;
    }
    get spanVectorField() {
        return this.spanField.getField(this.subFormSpanTypeState.vectorFieldId);
    }
    get spanTypeField() {
        return this.spanField.getField(this.subFormSpanTypeState.typeFieldId);
    }
    get spanTypeMapping() {
        return {
            [__1.SpanType.NextPole]: __1.SpanType.PreviousPole,
            [__1.SpanType.PreviousPole]: __1.SpanType.NextPole,
            [__1.SpanType.Other]: __1.SpanType.Other,
        };
    }
    get spanMidSpanIkePhoto() {
        if (!this.subFormSpanTypeState.midSpanIkePhotoFieldId) {
            throw new Error('Span is missing configured Mid Span IKE Photo field');
        }
        return this.spanField.getField(this.subFormSpanTypeState.midSpanIkePhotoFieldId);
    }
    spanValue(instance) {
        return new __1.SpanSubFormAdaptor(instance);
    }
    get spanAttachmentHeightFields() {
        return this.spanField.getAllNestedChildrenFieldsOfType(core_api_1.IkeFieldType.HEIGHT);
    }
}
exports.SpanSubForm = SpanSubForm;
//# sourceMappingURL=SpanSubForm.js.map